import { render, staticRenderFns } from "./bottomRight2.vue?vue&type=template&id=2191324e&scoped=true&"
import script from "./bottomRight2.vue?vue&type=script&lang=js&"
export * from "./bottomRight2.vue?vue&type=script&lang=js&"
import style0 from "./bottomRight2.vue?vue&type=style&index=0&id=2191324e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2191324e",
  null
  
)

export default component.exports